











































































































































import { Component, Vue } from "vue-property-decorator";
import "@/styles/MCQ.scss";
import { GeneralService } from "../services/general-service";
import config from "../services/api-config";
import router from "../router";
import store from "../store";
import AuthService from "../services/auth-service";
import Questions from "../components/Questions.vue";
import * as franc from "franc";

@Component({
  components: {
    question: Questions,
  },
})
export default class MCQ extends Vue {
  private service = new GeneralService();
  private items: GActivity[] = [];
  private questions: QuestionE[] = [];
  private questionComponentKey = 0;
  private answers: any = [];
  private sheetAnswerData: any = [];
  private isQuestion = false;
  private attempted: number = 0;
  private topicId: string = "";
  private level_id;
  private checkTopic = false;
  private auth = new AuthService();
  private mcqlimit = 10000;
  private chapterlimit = 10000;
  private topiclimit = 10000;
  private modalShow = false;
  private emptyAnswers: any = [];
  private isPastPaper = false;
  private isShortQuestions = false;
  private isLongQuestions = false;
  private savedOperations: any = [];
  private longShortPastPapers = false;
  boardId: any = '';
  classId: any = '';
  programnaem: any = '';

  private checkLang(str) {
    var lst = ["und", "urd", "fas", "pes", "skr", "arb", "uig"];
    var lan = franc(str, { minLength: 3 });

    return lst.indexOf(lan) > -1;
  }

  get itemsWithIndex() {
    return this.items.map((item, i) => ({ ...item, _rowIndex: i + 1 }));
  }

  filterWithIndex(row: any, filter: string) {
    const f = filter.toLowerCase();
    const rowNum = String(row._rowIndex);
    const name = (row.fullName || '').toLowerCase();
    return rowNum.includes(f) || name.includes(f);
  }

  stripHtml(html: string): string {
    if (!html) return '';
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || '';
  }

  answerAttempt(response) {
    if (this.answers !== undefined && response !== undefined) {
      let trueAns = this.answers.find(
        (e) => e.questionId === response.questionId
      );

      if (trueAns !== undefined) {
        trueAns.answer = true;
        trueAns.answerId = response.answerId;
      }

      let questionType = this.questions.find(
        (e) => e.qid === response.questionId
      );

      if (questionType !== undefined) {
        questionType.questiontype =
          response.styles == undefined ? 1 : response.styles == "red" ? 3 : 2;
      }

      this.attempted = this.answers.filter((e) => e.answer === true).length;
    }
  }

  private getSubjectRoute() {
    if (this.isPastPaper) {
      return 'mcqsubject?type=pastpaper';
    }
    if (this.isShortQuestions) {
      return 'mcqsubject?type=shortquestions' + (this.longShortPastPapers ? '&past=true' : '');
    }
    if (this.isLongQuestions) {
      return 'mcqsubject?type=longquestions' + (this.longShortPastPapers ? '&past=true' : '');
    }
    return 'mcqsubject';
  }

  private saveMCQ() {
    this.saveWatched();
    const route = this.getSubjectRoute();

    if (this.sheetAnswerData.length < 1) {
      for (let i = 0; i < this.answers.length; i++){
        let isExists = false;
        for (let j = 0; j < this.savedOperations.length; j++){
          if (this.answers[i].questionId == this.savedOperations[j].questionId && this.answers[i].isPastPaper == this.savedOperations[j].isPastPaper){
            this.savedOperations[j] = this.answers[i]
            isExists = true;
          }
        }
        if (!isExists){
          this.savedOperations.push(this.answers[i])
        }
      }
      this.service
        .insertSheetAnswers(config.createGuid(), this.topicId, this.savedOperations)
        .then((response) => {
          this.$router.push(route);
        })
        .catch((err) => {
          this.$router.push(route);
        });
    }
    else{
      for (let i = 0; i < this.answers.length; i++){
        let isExists = false;
        for (let j = 0; j < this.savedOperations.length; j++){
          if (this.answers[i].questionId == this.savedOperations[j].questionId && this.answers[i].isPastPaper == this.savedOperations[j].isPastPaper){
            this.savedOperations[j] = this.answers[i]
            isExists = true;
          }
        }
        if (!isExists){
          this.savedOperations.push(this.answers[i])
        }
      }
      this.service
        .updateSheetAnswers(
          this.sheetAnswerData.userMcqResponseId,
          this.topicId,
          this.savedOperations
        )
        .then((response) => {
          this.$router.push(route);
        })
        .catch((err) => {
          this.$router.push(route);
        });
    }
  }

  private getNumber() {
    if (this.isShortQuestions) {
      return 2
    } else if (this.isLongQuestions) {
      return 3
    } else {
      return 1
    }
  }

  private getTopics(id) {
    if (this.checkTopic) {
      // this.service.questions(id + ':1')
      //     .then(result => { this.questions = result; console.log(this.questions) })
      //     .catch(err => { console.error(`Error: ${err.message}`); });
    } else {
      this.checkTopic = true;
      this.topicId = id;
      this.service
        .topics(id)
        .then((result) => {
          this.items = result;
        })
        .catch((err) => {
          console.error(`Error: ${err.message}`);
        });
    }
  }

  goBack() {


    this.$router.push(this.getSubjectRoute());
  }

  private async getQuestions(id, name, index, data?) {
    if (index >= this.chapterlimit) {
      this.modalShow = true;
      return;
    }

    window.scrollTo(0, 0);
    this.isQuestion = true;
    this.$store.state.chapterSelectName = name;
    this.topicId = id;

    this.questions = [];

    // Extract contentIds and referenceValue from chapter item (from GetSubjectsByPeogramCombo response)
    let contentIds = '';
    let referenceValue = '';
    if (data && data.item) {
      if (data.item.content && data.item.content[0] && data.item.content[0].contentIds) {
        contentIds = data.item.content[0].contentIds;
      }
      if (data.item.referenceValue) {
        referenceValue = data.item.referenceValue;
      }
    }
    const contentType = this.isShortQuestions ? 'ShortQuestions' : this.isLongQuestions ? 'LongQuestions' : 'MCQs';
    const isArvo = (this.items && this.items.length > 0 && (this.items[0] as any).isArvo) ? true : false;
    const val = 'HADAF?' + contentIds + '?' + contentType + '??' + referenceValue + '?' + id +
      '?' + this.auth.session.userId + '?' + isArvo + '?' + (this.isPastPaper || this.longShortPastPapers ? 'true' : 'false');

    await this.service
      .getQuestionsWAnswersArvo(val)
      .then((result) => {
          this.answers = [];
          this.emptyAnswers = [];
          for (let quest of result) {
            let PastPaper = false;
            try {
              const boardsArr = quest.boards ? JSON.parse(quest.boards) : [];
              PastPaper = Array.isArray(boardsArr) && boardsArr.length > 0;
            } catch (e) { PastPaper = false; }
            this.answers.push({
              questionId: quest.qid,
              answer: false,
              answerId: "",
              isPastPaper: PastPaper,
            });
            try {
              quest.fullquestion = config.renderHTML(quest.fullquestion);
            } catch {
              result.splice(result.findIndex((e) => e.fullquestion == quest.fullquestion), 1);
            }
          }
          this.questions = result.splice(0, Math.min(result.length, this.mcqlimit));
          this.emptyAnswers = this.answers;
          this.getSavedData(id);
        })
        .catch((err) => {
          console.error(`Error: ${err.message}`);
        });
  }

  private getSavedData(id) {
    const val = this.auth.session.userId + '?' + id.toString();
    this.service.getSheetAnswers(val).then((data) => {
      let result = data.data;
      if (!result || result.length === 0) {
        this.sheetAnswerData = [];
        return;
      }
      this.sheetAnswerData = result[0];
      this.savedOperations = JSON.parse(result[0].operations);
      let answersTemp = JSON.parse(result[0].operations);
      for (let j = 0; j < this.answers.length; j++) {
        for (let i = 0; i < answersTemp.length; i++) {
          if (this.answers[j].questionId == answersTemp[i].questionId) {
            this.answers[j] = answersTemp[i];
          }
        }
      }
      this.attempted = this.answers.filter((e) => e.answer === true).length;
      this.questionComponentKey++;
    });
  }

  private saveWatched() {
    // this.saveElastic();

    var topicsWatched: McqAttempted = {
      mcqAttemptId: config.createGuid(),
      userId: this.auth.session.userId,
      topicId: this.topicId,
      operationOn: new Date(Date.now()),
      duration: this.attempted,
      percentage: this.isPastPaper ? -1 : -2,
    };

    this.service.insertMcq(topicsWatched).catch((err) => {
      console.error(`Error: ${err.message}`);
    });
  }

  saveElastic() {
    var msc = "";
    for (var que of this.answers) {
      if (que.answer == true) {
        msc = que.questionId + "=" + que.answer + ":";
        this.elasticSearchMCQs(msc);
      }
    }
  }

  elasticSearchMCQs(mcqs: string) {
    Vue.axios
      .post(
        "https://search.pgc.edu.pk/mcqs/wedgets/" +
          this.auth.session.userId +
          "!" +
          mcqs.split("=")[0],
        {
          body: { leftside: "mcqs", rightside: mcqs },
        }
      )
      .then((response) => {});
  }

  resetMCQ() {
    let spliced = 0;
    for (let i = this.savedOperations.length-1; i >= 0; i--){
      if (this.savedOperations[i].isPastPaper == this.isPastPaper){
        this.savedOperations.splice(i, 1);
        spliced++;
      }
    }
    
    this.attempted = 0;
    
    for (let i = 0; i < this.answers.length; i++){
      this.answers[i].answer = false;
      this.answers[i].answerId = ''  
    }
    
    this.questionComponentKey++;
  }

  data() {
    return {
      fields: [
        // A virtual column that doesn't exist in items
        "index",
        // A column that needs custom formatting
        { key: "fullName", label: "Chapter Name" },
        { key: "remaining", label: "Questions" },
      ],
      filter: null,
    };
  }

  private getType() {
    if (this.isLongQuestions) {
      return 3
    } else if (this.isShortQuestions) {
      return 2
    } else {
      return 1
    }
  }

  created() {
    debugger
    // window.addEventListener("beforeunload", this.handler);
    if (this.$route.query.type && this.$route.query.type == "pastpaper") {
      this.isPastPaper = true;
    }
console.log('this.isPastPaper',this.$route.query.past);
    if (this.$route.query.past && this.$route.query.past == 'true'){
        this.longShortPastPapers = true;
    }

    if (this.$route.query.type && this.$route.query.type == "shortquestions") {
      this.isShortQuestions = true;
    }

    if (this.$route.query.type && this.$route.query.type == "longquestions") {
      this.isLongQuestions = true;
    }

    this.level_id = localStorage[config.classLevl];
    if (
      this.level_id == "" ||
      this.level_id == undefined ||
      this.level_id == "null"
    ) {
      router.push("select");
    }

    if (
      this.$store.state.selectSubject == "" ||
      this.$store.state.selectSubject == undefined ||
      this.$store.state.selectSubject == "null"
    ) {
      if (this.$route.query.type && this.$route.query.past){
        router.push("mcqsubject?type=" + this.$route.query.type + "&past=true")
      }
      else if (this.$route.query.type){
        router.push("mcqsubject?type=" + this.$route.query.type)
      } else 
      router.push("mcqsubject");
    }

    const programSelectString = localStorage[config.programSelect];
    const programSelectData = JSON.parse(programSelectString);
    this.boardId = programSelectData.board.endsWith('s')
      ? programSelectData.board.slice(0, -1)
      : programSelectData.board;
    this.classId = programSelectData.part.replace(/\s+/g, '');
    if (this.auth.session.varification == '-1' || this.auth.session.varification == '0' || this.auth.session.varification == '1') {
      this.programnaem = programSelectData.name;
    } else {
      this.programnaem = this.auth.session.varification;
    }

    this.service
      .mcqArvoChapters(
        this.boardId + '?' + this.classId +
        '?HADAF?' + (this.isShortQuestions ? 'ShortQuestions' : this.isLongQuestions ? 'LongQuestions' : 'MCQs') +
        '?' + ((this.isPastPaper || this.longShortPastPapers) ? 'true' : 'false') +
        '?' + this.auth.session.userId +
        '?' + this.$store.state.selectSubject +
        '?' + this.$store.state.selectSubjectName,
        this.programnaem
      )
      .then((result) => {
        this.items = result;
        this.items.forEach(value => {
          value.fullName = value.fullName.replace(/^\d+[.)]\s*/, '');
        });
        if (this.items.findIndex((e) => e.fullName == 'Promo') > -1) {
          this.items.splice(this.items.findIndex((e) => e.fullName == 'Promo'), 1);
        }
      })
      .catch((err) => {
        console.error(`Error: ${err.message}`);
      });
  }

  beforeDestroy() {
    // window.removeEventListener("beforeunload", this.handler);
    // this.saveWatched();
  }

  // async handler(event) {
  //   event.preventDefault();
  //   try {
  //     // API call here
  //     await this.saveWatched();
  //     return ""; // Prompt with default browser message
  //   } catch (err) {
  //     return undefined; // Skip prompt
  //   }
  // }
}

interface ProvidedAnswers {
  questionId: string;
  answer: boolean;
  answerId: string;
}
